import { Slot, HisSlot } from "../api/models";
import { formatDate } from "@optimed/react";

export class SlotLookup {
  readonly dateKeyFormat = "yyyyMMddHHmm";
  docplannerSlotKeys: any[];
  hisSlotKeys: any[];

  constructor(docplannerSlots: Slot[], hisSlots: HisSlot[]) {
    this.docplannerSlotKeys = docplannerSlots.map(x => formatDate(x.start, this.dateKeyFormat));
    this.hisSlotKeys = hisSlots.map(x => formatDate(x.od, this.dateKeyFormat));
  }

  existsInDocplanner(date: Date | string | undefined) {
    return this.docplannerSlotKeys.includes(formatDate(date, this.dateKeyFormat));
  }

  existsInHis(date: Date | string | undefined) {
    return this.hisSlotKeys.includes(formatDate(date, this.dateKeyFormat));
  }
}
